const tokenKey = 'access_token'
const userKey = "userKey"
export default class Auth {
  /**
   * 获取localStorage中的token
   */
  public static getToken(): string | null {
    return localStorage.getItem(tokenKey)
  }

  /**
   * 保存token到localStorage中
   * @param token
   */
  public static setToken(token: string): void {
    localStorage.setItem(tokenKey, token)
  }

  /**
   * 移除localStorage中的token
   */
  public static clearToken(): void {
    return localStorage.removeItem(tokenKey)
  }

  /**
   * 从提取响应头中的token并保存到缓存中
   * @param headers 响应头
   */
  public static pickToken(headers: any): void {
    const token = headers['access-token'];
    if (token) {
      this.setToken(token);
    }
  }

  /**
   * 按照jwt标准格式往请求头中写入token
   * @param headers 请求头
   */
  public static appendToken(headers: any): void {
    const token = this.getToken()
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
  }

  /**
   * 获取用户JSON对象
   */
  public static GetUser(): { userId: string, tenantId?: string } | null {
    const useStr = localStorage.getItem(userKey);
    if (useStr) {
      return JSON.parse(useStr);
    } else {
      return null;
    }
  }

  /**
   * 保存用户对象
   * @param user 要保存的用户JSON对象
   */
  public static setUser(user: { userId: string, tenantId?: string }): void {
    localStorage.setItem(userKey, JSON.stringify(user))
  }
}

export interface AuthStatic {
  /**
   * 获取localStorage中的token
   */
  getToken(): string | null

  /**
   * 保存token到localStorage中
   * @param token
   */
  setToken(token: string): void

  /**
   * 移除localStorage中的token
   */
  clearToken(): void

  /**
   * 从提取响应头中的token并保存到缓存中
   * @param headers 响应头
   */
  pickToken(headers: any): void

  /**
   * 按照jwt标准格式往请求头中写入token
   * @param headers 请求头
   */
  appendToken(headers: any): void

  /**
   * 获取用户JSON对象
   */
  GetUser(): { userId: string, tenantId?: string } | null

  /**
   * 保存用户对象
   * @param user 要保存的用户JSON对象
   */
  setUser(user: { userId: string, tenantId?: string }): void
}
